// Imports
import Button from "@mui/material/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as _ from "lodash";
// UI Imports
import Grid from "@material-ui/core/Grid/Grid";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconArrowBack from "@material-ui/icons/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import IconClose from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import axios from "axios";

// App Imports
import { API_URL } from "../../../setup/config/env";
import params from "../../../setup/config/params";
import {
  capitalizeFirstLetter,
  nullToEmptyString,
  slug as generateSlug,
  subString,
} from "../../../setup/helpers";
import { messageShow } from "../../common/api/actions";
import EmptyMessage from "../../common/EmptyMessage";
import Image from "../../common/Image";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { createOrUpdate, remove } from "../api/actions/mutation";
import { listParent } from "../api/actions/query";
import routes, { getImageSource } from "../api/routes";
import CSVToArray from "./csv_parser";
import styles from "./styles";

// Component
class BulkCreate extends Component {
  constructor(props) {
    super(props);

    this.category = {
      _id: "",
      name: "",
      slug: "",
      parentId: null,
      parentSlug: "",
      parentName: "",
      description: "",
      image: "default.jpg",
      isFeatured: false,
      isPublished: true,
      action: "add",
    };

    this.state = {
      isLoading: false,
      isLoadingSubmit: false,
      isUploadingFile: false,
      loader: false,
      rowsPerPage: 20,
      page: 0,
      categories: [],
      selectedCategories: [],
      selectAll: false,
      summaryDialogOpen: false,
      bulkSummary: null,
      parentList: [],
    };
  }

  componentDidMount() {
    this.fetchCategories();
  }

  fetchCategories = async () => {
    try {
      const { data } = await axios.post(API_URL, { operation: "categoryListParent" });
      if (data.success && data.data) {
        this.setState({ parentList: data.data });
      }
    } catch (err) {
      console.error("Error fetching parent categories:", err);
    }
  };

  downloadTemplate = () => {
    const headers = [
      "Name",
      "Slug",
      "Parent Slug",
      "Description",
      "Image",
      "Is Featured",
      "Is Published",
      "Action"
    ];

    const sampleRows = [
      [
        '"Electronics & Gadgets"',
        '"electronics-gadgets"',
        '""',
        '"Smartphones, laptops, and consumer tech"',
        '"/datum/category/electronics.jpg"',
        '"TRUE"',
        '"TRUE"',
        '"Add"'
      ],
      [
        '"Smartphones & Accessories"',
        '"smartphones-accessories"',
        '"electronics-gadgets"',
        '"Mobile phones, cases, and chargers"',
        '"/datum/category/smartphones.jpg"',
        '"TRUE"',
        '"TRUE"',
        '"Add"'
      ],
      [
        '"Fashion & Apparel"',
        '"fashion-apparel"',
        '""',
        '"Men and women clothing & accessories"',
        '"/datum/category/fashion.jpg"',
        '"FALSE"',
        '"TRUE"',
        '"Add"'
      ],
      [
        '"Men Clothing"',
        '"mens-clothing"',
        '"fashion-apparel"',
        '"Shirts, pants, and jackets for men"',
        '"/datum/category/mens-clothing.jpg"',
        '"FALSE"',
        '"TRUE"',
        '"Add"'
      ]
    ];

    const csvContent =
      headers.join(",") +
      "\n" +
      sampleRows.map((r) => r.join(",")).join("\n") +
      "\n";

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "categories_template.csv";
    link.click();
  };

  onUpload = async (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    this.setState({
      loader: true,
      categories: [],
      selectedCategories: [],
      selectAll: false,
    });

    const { messageShow } = this.props;
    const { parentList } = this.state;
    const reader = new FileReader();

    reader.onload = async () => {
      this.setState({ loader: false });

      try {
        const data = CSVToArray(reader.result);
        if (!data || data.length < 2) {
          messageShow("CSV file is empty or invalid format.");
          return;
        }

        const rawHeaders = data.shift();
        const headers = rawHeaders.map((h) => h.trim().toLowerCase());
        const finalResult = [];

        data.forEach((row, index) => {
          if (!row || row.length === 0 || (row.length === 1 && !row[0].trim())) {
            return;
          }

          const eachObj = {};
          headers.forEach((h, i) => {
            eachObj[h] = (row[i] || "").trim();
          });

          const name = eachObj["name"] || "";
          if (!name) return;

          const slug = eachObj["slug"] || generateSlug(name);
          const parentSlug = eachObj["parent slug"] || eachObj["parent"] || "";
          const description = eachObj["description"] || "";
          const image = (eachObj["image"] && eachObj["image"].trim() !== "") ? eachObj["image"].trim() : "default.jpg";
          const isFeatured = (eachObj["is featured"] || "").toUpperCase() === "TRUE" || eachObj["is featured"] === "1";
          const isPublished = (eachObj["is published"] || "TRUE").toUpperCase() === "TRUE" || eachObj["is published"] === "1";
          const rawAction = (eachObj["action"] || "add").toLowerCase();
          const action = rawAction === "delete" ? "delete" : rawAction === "update" ? "update" : "add";

          let matchedParent = null;
          if (parentSlug) {
            matchedParent = parentList.find(
              (p) =>
                (p.slug && p.slug.toLowerCase() === parentSlug.toLowerCase()) ||
                (p.name && p.name.toLowerCase() === parentSlug.toLowerCase())
            );
          }

          finalResult.push({
            tempIndex: index,
            name,
            slug,
            parentSlug,
            parentId: matchedParent ? matchedParent._id : null,
            parentName: matchedParent ? matchedParent.name : parentSlug ? `Pending (${parentSlug})` : "None (Root Category)",
            description,
            image,
            isFeatured,
            isPublished,
            action,
            duplicateError: false,
          });
        });

        // Check for duplicates
        const seenNames = new Set();
        finalResult.forEach((cat) => {
          if (seenNames.has(cat.name.toLowerCase())) {
            cat.duplicateError = true;
          } else {
            seenNames.add(cat.name.toLowerCase());
          }
        });

        const validIndexes = finalResult
          .map((c, idx) => (c.duplicateError ? null : idx))
          .filter((idx) => idx !== null);

        this.setState({
          categories: finalResult,
          selectedCategories: validIndexes,
          selectAll: validIndexes.length === finalResult.length && finalResult.length > 0,
        });

        messageShow(`Parsed ${finalResult.length} categories from CSV.`);
      } catch (err) {
        console.error("CSV Parse error:", err);
        messageShow("Failed to parse CSV file: " + err.message);
      }
    };

    reader.readAsText(file);
    if (this.textInput) {
      this.textInput.value = "";
    }
  };

  handleSelectAll = (event) => {
    const { categories } = this.state;
    if (event.target.checked) {
      const validIndexes = categories
        .map((c, idx) => (c.duplicateError ? null : idx))
        .filter((idx) => idx !== null);
      this.setState({
        selectedCategories: validIndexes,
        selectAll: true,
      });
    } else {
      this.setState({
        selectedCategories: [],
        selectAll: false,
      });
    }
  };

  handleSelectCategory = (index) => {
    const { selectedCategories, categories } = this.state;
    const idxInSelected = selectedCategories.indexOf(index);
    let newSelected = [];

    if (idxInSelected === -1) {
      newSelected = [...selectedCategories, index];
    } else {
      newSelected = selectedCategories.filter((i) => i !== index);
    }

    const validCategoriesCount = categories.filter((c) => !c.duplicateError).length;
    this.setState({
      selectedCategories: newSelected,
      selectAll: newSelected.length === validCategoriesCount && validCategoriesCount > 0,
    });
  };

  deleteCategoryRow = (index) => {
    const { categories, selectedCategories } = this.state;
    const newCategories = [...categories];
    newCategories.splice(index, 1);

    const newSelected = selectedCategories
      .filter((i) => i !== index)
      .map((i) => (i > index ? i - 1 : i));

    this.setState({
      categories: newCategories,
      selectedCategories: newSelected,
    });
  };

  createSingleCategory = async (index) => {
    const { categories } = this.state;
    const { createOrUpdate, messageShow } = this.props;
    const item = categories[index];
    if (!item) return;

    try {
      const res = await createOrUpdate({
        category: {
          _id: item._id,
          name: item.name,
          slug: item.slug,
          parentId: item.parentId || null,
          description: item.description,
          image: item.image || "default.jpg",
          isFeatured: item.isFeatured,
          isPublished: item.isPublished,
          action: item.action || "add",
        },
      });
      if (res.data && !res.data.success) throw new Error(res.data.message || "Failed");
      messageShow(res.data.message || `Category "${item.name}" processed successfully.`);
      this.deleteCategoryRow(index);
    } catch (err) {
      messageShow(`Error saving "${item.name}": ${err.message}`);
    }
  };

  onSubmitSelected = async () => {
    const { categories, selectedCategories } = this.state;
    const { createOrUpdate, messageShow, listParent } = this.props;

    if (selectedCategories.length === 0) {
      messageShow("Please select at least one category to submit.");
      return;
    }

    this.setState({ isLoadingSubmit: true });

    let addedCount = 0;
    let updatedCount = 0;
    let deletedCount = 0;
    let errorCount = 0;
    const errorMessages = [];

    const selectedItems = selectedCategories.map((idx) => categories[idx]);
    const rootCategories = selectedItems.filter((c) => !c.parentSlug);
    const subCategories = selectedItems.filter((c) => Boolean(c.parentSlug));

    const createdParentsMap = {};

    // 1. Process Root Categories
    for (const item of rootCategories) {
      try {
        const res = await createOrUpdate({
          category: {
            _id: item._id,
            name: item.name,
            slug: item.slug,
            description: item.description,
            image: item.image || "default.jpg",
            isFeatured: item.isFeatured,
            isPublished: item.isPublished,
            action: item.action || "add",
          },
        });
        if (res.data && !res.data.success) throw new Error(res.data.message || "Save failed");
        if (res.data && res.data.data && res.data.data._id) {
          createdParentsMap[item.slug.toLowerCase()] = res.data.data._id;
        }
        
        const msg = (res.data?.message || "").toLowerCase();
        if (item.action === "delete" || msg.includes("deleted") || msg.includes("removed")) {
          deletedCount++;
        } else if (item.action === "update" || msg.includes("updated") || msg.includes("exists")) {
          updatedCount++;
        } else {
          addedCount++;
        }
      } catch (err) {
        errorCount++;
        errorMessages.push(`${item.name}: ${err.message || "Failed"}`);
      }
    }

    // Refresh parent categories list
    if (listParent) {
      await listParent(false);
    }
    await this.fetchCategories();

    // 2. Process Subcategories
    for (const item of subCategories) {
      try {
        let parentId = item.parentId;

        if (!parentId && item.parentSlug) {
          parentId = createdParentsMap[item.parentSlug.toLowerCase()];
          if (!parentId) {
            const match = this.state.parentList.find(
              (p) =>
                (p.slug && p.slug.toLowerCase() === item.parentSlug.toLowerCase()) ||
                (p.name && p.name.toLowerCase() === item.parentSlug.toLowerCase())
            );
            if (match) parentId = match._id;
          }
        }

        const res = await createOrUpdate({
          category: {
            _id: item._id,
            name: item.name,
            slug: item.slug,
            parentId: parentId || null,
            description: item.description,
            image: item.image || "default.jpg",
            isFeatured: item.isFeatured,
            isPublished: item.isPublished,
            action: item.action || "add",
          },
        });
        if (res.data && !res.data.success) throw new Error(res.data.message || "Save failed");
        
        const msg = (res.data?.message || "").toLowerCase();
        if (item.action === "delete" || msg.includes("deleted") || msg.includes("removed")) {
          deletedCount++;
        } else if (item.action === "update" || msg.includes("updated") || msg.includes("exists")) {
          updatedCount++;
        } else {
          addedCount++;
        }
      } catch (err) {
        errorCount++;
        errorMessages.push(`${item.name}: ${err.message || "Failed"}`);
      }
    }

    this.setState({
      isLoadingSubmit: false,
      bulkSummary: {
        total: selectedItems.length,
        added: addedCount,
        updated: updatedCount,
        deleted: deletedCount,
        errors: errorCount,
        errorMessages,
      },
      summaryDialogOpen: true,
    });

    if (listParent) {
      listParent(false);
    }
  };

  handleCloseSummaryDialog = () => {
    this.setState({ summaryDialogOpen: false });
    this.props.history.push(routes.categoryList.path);
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  back = () => {
    this.props.history.goBack();
  };

  render() {
    const { classes } = this.props;
    const {
      isLoading,
      isLoadingSubmit,
      isUploadingFile,
      loader,
      categories,
      selectedCategories,
      selectAll,
      rowsPerPage,
      page,
      bulkSummary,
      summaryDialogOpen,
    } = this.state;

    const validCategoriesCount = categories.filter((c) => !c.duplicateError).length;

    return (
      <>
        <div>
          {/* Toolbar */}
          <Toolbar className={classes.toolbar}>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              onClick={this.back}
            >
              <IconArrowBack />
            </IconButton>

            <Typography variant="h6" color="inherit" className={classes.grow}>
              Create Bulk Categories
            </Typography>
          </Toolbar>

          {/* Form and Guide Paper */}
          <Grid item xs={12} lg={6}>
            <SectionPaper padding>
              {isLoading ? (
                <BrandedLoading />
              ) : (
                <form>
                  {loader ? (
                    <Modal
                      open={true}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ height: "100vh" }}
                      >
                        <CircularProgress className={classes.progress} />
                      </Grid>
                    </Modal>
                  ) : null}

                  <Grid container className={classes.buttonUpload}>
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.grow}
                        gutterBottom
                      >
                        Upload Categories File
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <div style={{ marginTop: 10, marginBottom: 20 }}>
                        <input
                          accept={".csv"}
                          style={{ display: "none" }}
                          id={"contained-button-file"}
                          type={"file"}
                          onChange={this.onUpload}
                          ref={(ref) => (this.textInput = ref)}
                        />
                        <label htmlFor={"contained-button-file"}>
                          <Button
                            variant={"outlined"}
                            component={"span"}
                            type={"file"}
                            disabled={isUploadingFile}
                            fullWidth
                          >
                            Upload CSV file
                          </Button>
                        </label>
                      </div>
                    </Grid>

                    {/* <Grid item xs={12} sm={6}>
                      <div style={{ marginTop: 10, marginBottom: 20, paddingLeft: 10 }}>
                        <Button
                          variant={"outlined"}
                          color="primary"
                          onClick={this.downloadTemplate}
                          fullWidth
                        >
                          Download Template
                        </Button>
                      </div>
                    </Grid> */}

                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Steps to Bulk Upload:
                      </Typography>
                      <ol style={{ paddingLeft: "1.2rem", marginTop: 0 }}>
                        <li>📥 Download the categories file.</li>
                        <li>✏️ Make your changes.</li>
                        <li>
                          ⚙️ In the <strong>Action</strong> column, specify <strong>Add</strong>, <strong>Update</strong>, or <strong>Delete</strong> for each row.
                        </li>
                        <li>
                          📤 Upload the updated file using the button <strong>UPLOAD CSV FILE</strong>.
                        </li>
                      </ol>
                      <Typography variant="body2" style={{ marginTop: '8px' }}>
                        <strong>🛈Note:</strong>
                        <ul style={{ margin: '4px 0 0 0', paddingLeft: '1.2rem' }}>
                          <li><strong>ADD:</strong> If the category does not exist, it will be added. If the category already exists, it will be updated. (Default if left empty)</li>
                          <li><strong>UPDATE:</strong> Updates the category only if it already exists. If the category does not exist, an error will be displayed.</li>
                          <li><strong>DELETE:</strong> Deletes the category if it exists.</li>
                        </ul>
                      </Typography>
                    </Grid>
                  </Grid>
                </form>
              )}
            </SectionPaper>
          </Grid>

          {/* Table Paper */}
          <Grid item xs={12}>
            <SectionPaper>
              {isLoading ? (
                <BrandedLoading />
              ) : categories.length === 0 ? (
                <EmptyMessage message={"You have not added any categories yet."} />
              ) : (
                <>
                  {/* Selection Controls */}
                  <Grid
                    container
                    alignItems="center"
                    style={{ padding: "16px", borderBottom: "1px solid #e0e0e0" }}
                  >
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAll}
                            onChange={this.handleSelectAll}
                            disabled={validCategoriesCount === 0}
                          />
                        }
                        label={`Select All (${selectedCategories.length}/${validCategoriesCount})`}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: "auto" }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.onSubmitSelected}
                        disabled={selectedCategories.length === 0 || isLoadingSubmit}
                        startIcon={isLoadingSubmit ? <CircularProgress size={20} /> : null}
                      >
                        {isLoadingSubmit
                          ? "Submitting..."
                          : `Submit Selected (${selectedCategories.length})`}
                      </Button>
                    </Grid>
                  </Grid>

                  <Table padding={"normal"}>
                    <TableHead>
                      <TableRow>
                        <TableCell width={50}>Select</TableCell>
                        <TableCell width={85}>Image</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Slug</TableCell>
                        <TableCell>Parent Category</TableCell>
                        <TableCell>Featured</TableCell>
                        <TableCell>Published</TableCell>
                        <TableCell>Action</TableCell>
                        <TableCell width={180} align="center">
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {categories
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map(
                          (
                            {
                              image,
                              name,
                              slug,
                              parentName,
                              isFeatured,
                              isPublished,
                              action,
                              duplicateError,
                            },
                            i
                          ) => {
                            const actualIndex = page * rowsPerPage + i;
                            return (
                              <TableRow
                                key={actualIndex}
                                style={{
                                  backgroundColor: duplicateError
                                    ? "rgba(255, 0, 0, 0.1)"
                                    : "inherit",
                                }}
                              >
                                <TableCell>
                                  <Checkbox
                                    checked={selectedCategories.includes(actualIndex)}
                                    onChange={() => this.handleSelectCategory(actualIndex)}
                                    disabled={duplicateError}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Image
                                    src={getImageSource(image)}
                                    defaultSrc={getImageSource()}
                                  />
                                </TableCell>
                                <TableCell>{subString(name, 30)}</TableCell>
                                <TableCell>{slug}</TableCell>
                                <TableCell>{parentName}</TableCell>
                                <TableCell>{isFeatured ? "Yes" : "No"}</TableCell>
                                <TableCell>{isPublished ? "Yes" : "No"}</TableCell>
                                <TableCell>{(action || "Add").toUpperCase()}</TableCell>
                                <TableCell>
                                  <Grid item xs={12} className={classes.buttonsContainer}>
                                    <IconButton
                                      type="button"
                                      aria-label="Close"
                                      color="secondary"
                                      onClick={() => this.deleteCategoryRow(actualIndex)}
                                    >
                                      <IconClose />
                                    </IconButton>
                                    <IconButton
                                      type="button"
                                      aria-label="Save"
                                      color="primary"
                                      onClick={() => this.createSingleCategory(actualIndex)}
                                    >
                                      <CheckIcon />
                                    </IconButton>
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            );
                          }
                        )}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePagination
                          rowsPerPageOptions={[20, 50, 100]}
                          count={categories.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={this.handleChangePage}
                          onRowsPerPageChange={this.handleChangeRowsPerPage}
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </>
              )}
            </SectionPaper>
          </Grid>
        </div>

        {/* Summary Dialog */}
        <Dialog open={summaryDialogOpen} onClose={this.handleCloseSummaryDialog}>
          <DialogTitle>Bulk Upload Summary</DialogTitle>
          <DialogContent>
            {bulkSummary && (
              <div>
                <p>
                  <strong>Total:</strong> {bulkSummary.total} Categories
                </p>
                <p>
                  <strong>Added:</strong> {bulkSummary.added} Categories Added successfully
                </p>
                <p>
                  <strong>Updated:</strong> {bulkSummary.updated} Categories Updated successfully
                </p>
                <p>
                  <strong>Deleted:</strong> {bulkSummary.deleted} Categories Deleted successfully
                </p>
                <p>
                  <strong>Errors:</strong> {bulkSummary.errors} Categories Failed
                </p>
                {bulkSummary.errorMessages.length > 0 && (
                  <>
                    <p>
                      <strong>Error Details:</strong>
                    </p>
                    <ul>
                      {bulkSummary.errorMessages.map((msg, index) => (
                        <li key={index}>{msg}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseSummaryDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

// Component Properties
BulkCreate.propTypes = {
  createOrUpdate: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  listParent: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

// Component State
function bulkCreateState(state) {
  return {
    categoriesParent: state.categoriesParent,
    user: state.user,
  };
}

export default connect(bulkCreateState, {
  createOrUpdate,
  remove,
  listParent,
  messageShow,
})(withStyles(styles)(BulkCreate));
